module.exports = {
  ACTIVE: 'ACTIVE',
  CONCLUDED: 'CONCLUDED',
  DELETED_BY_USER: 'DELETED_BY_USER',
  DELETED_BY_PSP: 'DELETED_BY_PSP'
};
